<h4 mat-dialog-title>{{data.title || 'Visualizar Documento'}}</h4>

<div mat-dialog-content>
    <iframe [src]="safeUrl" frameborder="0" scrolling="no">Este navegador não suporta iframes</iframe>
</div>

<div class="actions mt-3" align="end" mat-dialog-actions>
    <button class="btn btn-outline-secondary" (click)="close(true)">
        <i class="fas fa-undo mr-2" *ngIf="data.title != null"></i>
        <span>{{(data.title != null ? "Voltar para a edição do formulário" : "Fechar")}}</span>
    </button>

    <button class="btn btn-primary ml-3" (click)="close()" *ngIf="data.title != null">
        <i class="fas fa-check mr-2"></i>
        <span>Prosseguir com o envio do formulário</span>
    </button>
</div>
